import styled from 'styled-components';

import { Theme, Css } from 'themes';

export const JobPromotionStyles = {
  CenteredContainer: styled(Theme.Wrapper)`
    ${Css.responsiveCenterWide};
  `,
};
